import * as types from "./types";
import { createReducer } from "../../util/index";

const initialState = {
  loading: false,
  data: [],
};

export default createReducer(initialState)({
  [types.BONUS_CLAIM_LIST]: (state, action) => ({
    ...state,
    list: action.payload,
  }),
});

